var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container",staticStyle:{"font-size":"1.5625vw","font-weight":"500"}},[_vm._v("产品安装视频下载")]),_c('div',{staticClass:"top"},[_c('p',[_c('video',{attrs:{"width":"368","controls":""}},[_c('source',{attrs:{"src":require("../../../assets/mock/serve/产品宣传.mp4"),"type":"video/mp4"}})])])])])
}]

export { render, staticRenderFns }